import axios from "../axios"
import { BASE_URL, encodeQueryFilter } from "../Utils";


export function getAllPhlebs() {
  return axios({
    "url": `${BASE_URL}/users/phlebs`,
    "method": "get",
  })
}

export function getAllDrivers() {
  return axios({
    "url": `${BASE_URL}/users/drivers`,
    "method": "get",
  })
}

export function getAllFacility(filter = {}) {
  return axios({
    url: `${BASE_URL}/facilities/facilities?filter=${encodeQueryFilter(filter)}`,
    method: "get",
  });
}